import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api, auth } from '../lib/api'

export default function Login() {
  const nav = useNavigate()
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  async function submit(e) {
    e.preventDefault()
    setErr(''); setLoading(true)
    try {
      const { token, staff } = await api.login(phone, password)
      auth.save(token, staff)
      nav('/orders')
    } catch (e) { setErr(e.message) } finally { setLoading(false) }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <form className="card" style={{ padding: 32, width: 360 }} onSubmit={submit}>
        <h2 style={{ fontSize: 18, marginBottom: 22 }}>ETC 售后后台</h2>
        <div className="field">
          <label>手机号</label>
          <input className="input" value={phone} onChange={e => setPhone(e.target.value)} autoFocus />
        </div>
        <div className="field">
          <label>密码</label>
          <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        <button className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
          {loading ? '登录中…' : '登录'}
        </button>
        <div className="err">{err}</div>
      </form>
    </div>
  )
}
